import Graph from '@core/utils/Graph';

export function buildTaxonomyGraph(tree, graphId) {
  const edges = [];
  const nodes = [];

  const rec = (node, order, parentId) => {
    edges.push({ from: parentId, to: node.data.id });
    nodes.push({ ...node.data, order });
    node.children.forEach((child, childOrder) => rec(child, childOrder, node.data.id));
  };
  tree.forEach((node, order) => rec(node, order, null));

  return new Graph(graphId, nodes, edges, null);
}

export function sortSiblingsByOrder(items) {
  const orders = items.map(({ data }) => data.order);
  const hasMeaningfulOrder = items.length > 1 && new Set(orders).size === items.length;
  if (!hasMeaningfulOrder) return items;
  return [...items].sort((a, b) => a.data.order - b.data.order);
}
